import React, { useState, useMemo } from 'react'
import { getUserInfoSync } from '../../config/api'
import apiClient from '../../config/api'
import { API_ENDPOINTS } from '../../config/api'
import Swal from 'sweetalert2'
import LaybyList from '../Cashier/Layby/LaybyList'
import LaybyDetail from '../Cashier/Layby/LaybyDetail'

const brandColors = {
  primary: '#1338b5',
  mid: '#1f4dc7',
  bright: '#5c8ef0',
}

// Helper function to get branch_id from userInfo
const getBranchId = (userInfo) => {
  if (!userInfo) {
    return null
  }

  if (typeof userInfo.branch === 'number') {
    return userInfo.branch
  }

  if (typeof userInfo.branch === 'object' && userInfo.branch !== null) {
    if (typeof userInfo.branch.id === 'number') {
      return userInfo.branch.id
    }
  }

  return (
    userInfo.branch_id ||
    userInfo.assigned_branch_id ||
    userInfo.branchId ||
    null
  )
}

const AdminLayby = () => {
  const [activeView, setActiveView] = useState('list') // 'list', 'detail'
  const [selectedLayby, setSelectedLayby] = useState(null)
  const userInfo = useMemo(() => getUserInfoSync(), [])

  const handleViewChange = (view, layby = null) => {
    setActiveView(view)
    setSelectedLayby(layby)
  }

  return (
    <>
      <div className="pagetitle">
        <h1>Layby Management</h1>
      </div>
      <section className="section">
        <div className="card shadow-sm border-0">
          <div className="card-body">
            {activeView === 'list' && (
              <LaybyList
                userInfo={userInfo}
                onViewDetail={(layby) => handleViewChange('detail', layby)}
              />
            )}
            {activeView === 'detail' && selectedLayby && (
              <LaybyDetail
                layby={selectedLayby}
                userInfo={userInfo}
                branchId={getBranchId(userInfo)}
                onBack={() => handleViewChange('list')}
                onPaymentSuccess={() => {
                  // Refresh layby details after payment
                  apiClient
                    .get(`${API_ENDPOINTS.LAYBY}${selectedLayby.id}/`)
                    .then((response) => {
                      setSelectedLayby(response.data)
                      Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Payment recorded successfully',
                        confirmButtonColor: brandColors.primary,
                      })
                    })
                    .catch((error) => {
                      console.error('Error refreshing layby:', error)
                    })
                }}
              />
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default AdminLayby
